import { render } from "./OfficialBusinessModal.vue?vue&type=template&id=0a9930e4"
import script from "./OfficialBusinessModal.vue?vue&type=script&lang=js"
export * from "./OfficialBusinessModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__